import React, { Component } from 'react'
import { connect } from 'react-redux'
import { firestoreConnect } from 'react-redux-firebase'
import { compose } from 'redux'
import { Breadcrumb, Container, Row, Col } from 'react-bootstrap'
import ProjectDetailsComponent from './ProjectDetailsComponent'
import WebLinksComponent from './WebLinksComponent'
import ReactCountryFlag from "react-country-flag";
import { owners } from '../../Consts'
import BottomSide from '../components/BottomSide'
import { Helmet } from 'react-helmet';

class ProjectDetailsPage extends Component {

    componentDidMount() {
        //console.log("project:", this.props.project);
    }

    getProjectOwnerName = (ownerId) => {
        const ownerIndex = parseInt(ownerId);
        return owners[ownerIndex] || "undefined";
    }

    render() {
        const currentUrl = window.location.href;
        const { project, news } = this.props;

        const metaTitle = "Projects - Bright Youth Community";
        const metaDescription = "Welcome to our page featuring the projects our association is involved in and the developments related to these projects. This page is like an exhibition showcasing our areas of work.";

        return (
            <div>
                <Helmet>
                    <title>{metaTitle}</title>
                    <meta name="description" content={metaDescription} />
                    <link rel="canonical" href={currentUrl} />

                    <meta property="og:title" content={metaTitle} />
                    <meta property="og:description" content={metaDescription} />
                    <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/bycbase-c9b76.appspot.com/o/byc%2Fbyc.jpg?alt=media&token=62f03ab7-9dbe-4f98-9481-cd2d4e270b83" />
                    <meta property="og:url" content={currentUrl} />
                    <meta property="og:type" content="website" />

                    <meta name="twitter:card" content="summary_large_image" />
                    <meta name="twitter:title" content={metaTitle} />
                    <meta name="twitter:description" content={metaDescription} />
                    <meta name="twitter:image" content="https://firebasestorage.googleapis.com/v0/b/bycbase-c9b76.appspot.com/o/byc%2Fbyc.jpg?alt=media&token=62f03ab7-9dbe-4f98-9481-cd2d4e270b83" />
                </Helmet>

                <Container className="mt-4">
                    <Breadcrumb>
                        <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                        <Breadcrumb.Item href="/projects">Projects</Breadcrumb.Item>
                        <Breadcrumb.Item active>{project?.title}</Breadcrumb.Item>
                    </Breadcrumb>
                </Container>

                <Container className="mt-4 bg-light" style={{ minHeight: '90px' }}>
                    <Row>
                        <Col xs={12}>
                            <h2>{project?.title}</h2>
                            <ReactCountryFlag
                                countryCode="TR"
                                svg
                                style={{
                                    fontSize: '2em',
                                    lineHeight: '2em',
                                }}
                            />
                            <span> {this.getProjectOwnerName(project?.owner)} </span>
                        </Col>
                    </Row>
                    <WebLinksComponent project={project} />

                </Container>

                <ProjectDetailsComponent
                    project={project}
                    news={news}
                />

                <div className='mb-5'>
                    <BottomSide />
                </div>

            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        project: state.firestore.data.project,
        news: state.firestore.ordered.news,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        //createQuestions: (questions, courseId, testId) => dispatch()
    }
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    firestoreConnect(props => {
        const { projectId } = props.match.params;
        return [
            { collection: 'projects', storeAs: 'project', doc: projectId },
            { collection: 'news', storeAs: 'news', where: [['projectId', '==', projectId]], orderBy: ['created', 'desc'] }
        ]
    })
)(ProjectDetailsPage)